import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["onBackClick", "isMailboxReferral", "offsetTitle", "topAligned"];
import { Box, Heading, Text } from '@wix/design-system';
import clsx from 'clsx';
import React from 'react';
import { HeaderWrapper } from '../HeaderWrapper';
import s from './resultsHeader.scss';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
export const ResultsHeader = _ref => {
  let onBackClick = _ref.onBackClick,
    _ref$isMailboxReferra = _ref.isMailboxReferral,
    isMailboxReferral = _ref$isMailboxReferra === void 0 ? false : _ref$isMailboxReferra,
    _ref$offsetTitle = _ref.offsetTitle,
    offsetTitle = _ref$offsetTitle === void 0 ? false : _ref$offsetTitle,
    _ref$topAligned = _ref.topAligned,
    topAligned = _ref$topAligned === void 0 ? false : _ref$topAligned,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const alignHeaderToTop = topAligned || offsetTitle;
  const titleKey = isMailboxReferral ? 'domain_search_gate.business_email_results.title' : 'domain_search_gate.results.header_ai';
  return /*#__PURE__*/React.createElement(HeaderWrapper, _extends({
    onBackClick: onBackClick,
    verticalAlign: alignHeaderToTop ? 'top' : 'middle'
  }, props), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    align: "center",
    gap: "SP2",
    className: clsx(s.headingGap, offsetTitle && s.offsetTitle)
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.resultsHeaderTitle
  }, t(titleKey)), isMailboxReferral && /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal",
    secondary: true
  }, t('domain_search_gate.business_email_results.subtitle'))));
};
//# sourceMappingURL=ResultsHeader.js.map